module.exports = __webpack_public_path__ + "img/car_icon.4a9d2712.svg";